import { GeneratedReport } from "./GeneratedReport";

export interface PagedData<T> {
  result: T;
  pageCount: number;
  totalCount: number;
}

export const EMPTY_PAGED_GENERATED_REPORTS: PagedData<GeneratedReport[]> = {
  pageCount: 0,
  totalCount: 0,
  result: [],
};
